import React from 'react';
import { useSelector } from 'react-redux';
import KpiDetailDepartment from './KpiDetailDepartment';
import KpiDetailTeacher from './KpiDetailTeacher';

const KpiDetailWrapper = () => {
  const { user, activeRole } = useSelector(s => s);
  const effectiveRole = activeRole !== null ? activeRole : user?.role;

  // Role-based detail screens
  // The Layout component in each detail screen will handle authentication
  if (effectiveRole === 1) {
    return <KpiDetailTeacher />;
  }
  if (effectiveRole === 2 || effectiveRole === 3) {
    return <KpiDetailDepartment />;
  }
  // Rector or others - use teacher interface for now
  return <KpiDetailTeacher />;
};

export default KpiDetailWrapper;
